// src/beta/components/DocumentTile.tsx
import type { V1DocumentSummary } from '@/beta/types/dossier';

interface Props {
  doc: V1DocumentSummary;
  onTap: (docId: string) => void;
}

/** § 6.4 (4) tile: square card with thumbnail or placeholder + title + meta.
 *  Tapping fires onTap(docId) so the parent can open <DocumentModal>. */
export function DocumentTile({ doc, onTap }: Props) {
  return (
    <button
      type="button"
      aria-label={doc.title}
      onClick={() => onTap(doc.id)}
      style={{
        background: 'var(--vm-dark-card)',
        border: '1px solid var(--vm-border)',
        padding: 'var(--vm-s-2)',
        textAlign: 'left',
        cursor: 'pointer',
        color: 'var(--vm-warm-white)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--vm-s-1)',
      }}
    >
      <div
        style={{
          aspectRatio: '1 / 1',
          background: '#000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {doc.thumbnail_url ? (
          <img
            src={doc.thumbnail_url}
            alt=""
            loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <span
            data-testid="document-tile-placeholder"
            style={{
              fontFamily: 'var(--vm-font-heading)',
              fontSize: 56,
              color: 'var(--vm-stone)',
              opacity: 0.6,
            }}
          >
            {(doc.type || '?').charAt(0).toUpperCase()}
          </span>
        )}
      </div>

      <div
        style={{
          fontFamily: 'var(--vm-font-heading)',
          fontSize: 14,
          color: 'var(--vm-warm-white)',
        }}
      >
        {doc.title}
      </div>
      <div
        style={{
          fontFamily: 'var(--vm-font-heading)',
          fontSize: 10,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'var(--vm-stone)',
        }}
      >
        {doc.type} — {doc.page_count ?? 0} pages
      </div>
    </button>
  );
}
